export class ValidateSearch {

  static isPostCode(search: string): boolean {
    search = search.replace(/\s/g, "");
    let regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i;
    return regex.test(search);
  }

  static isTitleInfo(search: string): boolean {

    // Changed titleno regex to "^[A-Z]{0,3}[0-9]{1,6}[ZT]?$"
    if (!search.includes(' ')) {
      let regex = /^[A-Z]{0,3}[0-9]{1,6}[ZT]?$/g;
      let testResult = regex.test(search.toUpperCase());
      return testResult;
    }
    return false;
  }

  static IsUPRN(search: string): boolean {
    let regex = /^-?\d+\.?\d*$/
    return regex.test(search);
  }

  static isAddressSearch(search: string): boolean {
    if (search) {
      return true;
    }
    return false;
  }
}
